import {DEEP_LINK} from './types';

export const getDeepLink = data => ({
  type: DEEP_LINK,
  payload: data,
});
